/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Home_TitleInputs */

const en_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI – Best AI Tools for Every Task (2026)`)
};

const zh_seo_home_title = /** @type {(inputs: Seo_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI 工具导航 – 每个任务最好的 AI 工具 (2026)`)
};

/**
* | output |
* | --- |
* | "Seek AI – Best AI Tools for Every Task (2026)" |
*
* @param {Seo_Home_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_home_title = /** @type {((inputs?: Seo_Home_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Home_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_home_title(inputs)
	return zh_seo_home_title(inputs)
});
export { seo_home_title as "seo.home.title" }